import { lazy } from 'react';

export const AccountsCreateProfileScreenLazy = lazy(async () => {
  const { AccountsCreateProfileScreen } = await import('./accounts-create-profile.screen.tsx');
  return { default: AccountsCreateProfileScreen };
});
